import { render, staticRenderFns } from "./ClientSettingEdit.vue?vue&type=template&id=ec952af4&scoped=true"
import script from "./ClientSettingEdit.vue?vue&type=script&lang=js"
export * from "./ClientSettingEdit.vue?vue&type=script&lang=js"
import style0 from "./ClientSettingEdit.vue?vue&type=style&index=0&id=ec952af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec952af4",
  null
  
)

export default component.exports